<template>
    <div class="lists">
        <el-card class="list" v-for="(value, index) in list" :key="index" shadow="hover">
            <div slot="header" class="list-header">
                <div class="header-left">
                    <img :src="value.user.photo" />
                    <span>{{ value.user.name }}</span>
                    <span class="course-name">{{ value.course.name }}</span>
                </div>
                <div class="header-right">
                    {{ value.time }}
                </div>
            </div>
            <div class="list-content-name" @click="toDetail(value)">
                {{ value.title }}
                <img v-if="value.voice" class="list-content-voice" src="@/assets/housework/voice.png" />
                <span v-if="value.status"
                    :class="[value.status === '待反馈' ? 'wait-feedback' : (value.status === '已批改' ? 'status-corrected' : 'wait-correct')]">{{
                        value.status }}</span>
            </div>
            <div class="list-content-text" @click="toDetail(value)">{{ value.content }}</div>
            <div class="list-feedback" v-if="cate == 1" @click="toDetail(value)">
                <div>
                    <span>已反馈：{{ value.feedback_number }}</span>
                    <span>
                        未反馈：
                        <span class="no-feedback">{{ value.no_number }}</span>
                    </span>
                </div>
                <div>
                    <span v-if="value.uncorrected_number > 0" class="teacher-wait-correct">{{
                        value.uncorrected_number
                    }}</span>
                    <img class="icon-right" src="@/assets/housework/right.png" />
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    data () {
        return {
            cate: localStorage.getItem('cate'),
            // status: 3
        }
    },
    props: {
        list: [Array]
    },
    mounted () {

    },
    methods: {
        // 跳转作业详情页
        toDetail (item) {
            const { id } = item
            this.$router.push('/houseworkDetail?id=' + id)
        }
    }

}
</script>

<style lang="scss" scoped>
$color1: #7C8184;
$color2: #1B2422;

@mixin status($color, $margin: 4px) {
    margin-left: $margin;
    padding: 0 1px;
    vertical-align: middle;
    color: $color;
    font-size: 10px;
    border: 1px solid $color;
    border-radius: 4px;

}

.lists {
    display: flex;
    justify-self: flex-start;
    flex-wrap: wrap;

    .list {
        width: 23.7%;
        margin: 8px;

        &:hover {
            box-shadow: 0px 10px 24px 0px #d8e2eb;
        }

        // margin-top: 20px;
        // margin-right: 17px;
        // &:nth-child(4n) {
        //     margin-right: 0;
        // }

        .list-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .header-left {
                display: flex;
                align-items: center;
                font-size: 14px;

                img {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                }

                span:nth-child(2) {
                    margin: 0 8px;
                }

                .course-name {
                    @include status(#2881CD, 0)
                }


            }

            .header-right {
                font-size: 12px;
                color: $color1;
            }
        }

        >>>.el-card__header {
            padding: 12px;
        }

        >>>.el-card__body {
            padding: 12px;
        }

        .list-content-name {
            display: flex;
            align-items: center;
            cursor: pointer;
            font-size: 16px;
            color: $color2;

            .list-content-voice {
                margin-left: 4px;
            }

            .status-corrected {
                @include status(#FFC130);
                background: #FFF7E6;
            }

            .wait-feedback {
                @include status(#F24D19);
                background: #FFE9E5;
            }

            .wait-correct {
                @include status(#28CD44);
                background: #E5FFE9;
            }
        }

        .list-content-text {
            margin: 8px 0;
            line-height: 22px;
            height: 42px;
            text-emphasis: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            font-size: 14px;
            color: $color1;
            cursor: pointer;
        }

        .list-feedback {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            padding-top: 14px;
            box-sizing: border-box;
            font-size: 14px;
            border-top: 1px solid #F4F4F5;
            cursor: pointer;

            span:nth-child(2) {
                margin: 0 24px;


            }

            .teacher-wait-correct {
                display: inline-block;
                margin-top: 3px;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                font-size: 10px;
                color: #fff;
                text-align: center;
                line-height: 16px;
                background: #F24519;
            }

            .no-feedback {
                color: #F24D19;
            }

            .icon-right {
                float: right;
                vertical-align: middle;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/list/HouseworkList.vue